import { BaseModel } from '@/api/base-model'
import { TypeformFormAPI } from '@/api/backend-client'

export enum TypeformResponseAnswerHookActionType {
    CREATE_REFERRAL = 'create-referral',
}

export interface TypeformResponseAnswerHookOptions {
    referralType?: string
    pipeline?: string
    phase?: string
}

export class TypeformResponseAnswerHook extends BaseModel<TypeformResponseAnswerHook> {
    protected collectionName = TypeformFormAPI.collectionName

    constructor(
        public id: string,
        public formId: string,
        public fieldId: string,
        public actionType: TypeformResponseAnswerHookActionType,
        public answers: any[] = [],
        public options: TypeformResponseAnswerHookOptions[] = [],
    ) { super(id) }

    toRequestData(): any {
        return {
            id: this.id,
            formId: this.formId,
            fieldId: this.fieldId,
            actionType: this.actionType,
            answers: this.answers,
            options: this.options,
        }
    }

    static fromData(data: any): TypeformResponseAnswerHook {
        if (data === null || typeof data === 'string' || data instanceof TypeformResponseAnswerHook) {
            return data
        }

        return new TypeformResponseAnswerHook(
            data.id,
            data.formId,
            data.fieldId,
            data.actionType,
            data.answers,
            data.options,
        )
    }
}
